import React, { forwardRef } from "react";
const FormBuilderFormInterfaceSubmitButton = forwardRef(({ item, disabled, t, onClick }, ref) => {
  if (!item) return null;
  const submitButtonData = item == null ? void 0 : item.elements;
  return /* @__PURE__ */ React.createElement("div", { className: item.class }, /* @__PURE__ */ React.createElement("button", { type: "submit", disabled, ref, onClick }, t(submitButtonData == null ? void 0 : submitButtonData.find((el) => el.nodeName === "button").nodeValue)));
});
FormBuilderFormInterfaceSubmitButton.displayName = "FormBuilderFormInterfaceSubmitButton";
export default React.memo(FormBuilderFormInterfaceSubmitButton);
